module.exports = __webpack_public_path__ + "static/media/refund.ce34ade9.png";